import { render, staticRenderFns } from "./PersonalStaffNotes.vue?vue&type=template&id=834b3d56&scoped=true&"
import script from "./PersonalStaffNotes.vue?vue&type=script&lang=js&"
export * from "./PersonalStaffNotes.vue?vue&type=script&lang=js&"
import style0 from "./PersonalStaffNotes.vue?vue&type=style&index=0&id=834b3d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834b3d56",
  null
  
)

export default component.exports